import {emptySplitApi} from './EmptySplitApi'
import {
    CHANGE_SEC_USAGER_PASSWORD,
    CHANGE_SEC_USAGER_PASSWORD_LOGGED_IN,
    LOAD_POLPWPOL_BY_USERNAME,
    MENU_DATA,
    GET_ALL_CARTE_ACCESS_BY_USAGER_ID,
    GET_ONE_CARTE_ACCESS_BY_USAGER_ID,
    GET_SEC_USAGER_VM_FC,
    ADD_ONE_SEC_USAGER,
    UPDATE_ONE_SEC_USAGER,
    RESET_SEC_USAGER_PASSWORD,
    DELETE_ONE_SEC_USAGER,
    GET_SEC_GROUPES_DISP_BY_USAGER,
    GET_SEC_GROUPES_ASSOCIE_USAGER,
    ADD_SEC_GROUPES_USAGER,
    DELETE_SEC_GROUPES_USAGER,
    LOAD_POLPWPOL,
    NEW_POLPWPOL,
    ADD_UPDATE_POLPWPOL,
    DELETE_POLPWPOL,
    LOAD_POLPWPOL_USAGER,
    UPDATE_POLPWPOL_USAGER
} from "../UrlConstants"

const enhancedApi = emptySplitApi.enhanceEndpoints({
    addTagTypes: ["Usager.groupes", "PolPwPol", "PolPwPolUsager"]
})

const extendedApi = enhancedApi.injectEndpoints({
    endpoints: (build) => ({
        fetchMenuData: build.query({
            query: () => {
                return ({
                    url: MENU_DATA,
                    method: 'GET'
                });
            },
        }),
        changeSecUsagerPasswordLoggedIn: build.mutation({
            query: (params) => {
                return ({
                    url: CHANGE_SEC_USAGER_PASSWORD_LOGGED_IN,
                    method: 'POST',
                    data: params
                });
            },
        }),
        changeSecUsagerPassword: build.mutation({
            query: (params) => {
                return ({
                    url: CHANGE_SEC_USAGER_PASSWORD,
                    method: 'POST',
                    data: params
                });
            },
        }),
        loadPolPwPolByUsername: build.query({
            query: (username) => {
                return ({
                    url: LOAD_POLPWPOL_BY_USERNAME,
                    method: 'GET',
                    params: {username: username}
                });
            },
        }),
        getAllCartesAccessByUsagerId: build.query({
            query: (secUsagerId) => {
                return ({
                    url: GET_ALL_CARTE_ACCESS_BY_USAGER_ID,
                    method: 'GET',
                    params: { secUsagerId }
                });
            },
        }),
        getOneCarteAccessByUsagerId: build.query({
            query: (secUsagerId) => {
                return ({
                    url: GET_ONE_CARTE_ACCESS_BY_USAGER_ID,
                    method: 'GET',
                    params: { secUsagerId }
                });
            }
        }),
        getSecUsagerVmFc: build.query({
            query: (noEmploye) => {
                return ({
                    url: GET_SEC_USAGER_VM_FC,
                    method: 'GET',
                    params: { noEmploye }
                });
            },
            providesTags: result => [{ type: 'SecUsager', id: result.id }],
        }),
        addOneSecUsager: build.mutation({
            query: (secUsager) => {
                return ({
                    url: ADD_ONE_SEC_USAGER,
                    method: 'POST',
                    data: secUsager
                });
            },
            invalidatesTags: (result, error, secUsager) => [{ type: 'SecUsager', id: secUsager.id }],
        }),
        updateOneSecUsager: build.mutation({
            query: (secUsager) => {
                return ({
                    url: UPDATE_ONE_SEC_USAGER,
                    method: 'PUT',
                    data: secUsager
                });
            },
            invalidatesTags: (result, error, secUsager) => [{ type: 'SecUsager', id: secUsager.id }],
        }),
        resetSecUsagerPassword: build.mutation({
            query: (secUsager) => {
                return ({
                    url: RESET_SEC_USAGER_PASSWORD,
                    method: 'PUT',
                    data: secUsager
                });
            },
            invalidatesTags: (result, error, secUsager) => [{ type: 'SecUsager', id: secUsager.id }],
        }),
        deleteOneSecUsager: build.mutation({
            query: (secUsager) => {
                return ({
                    url: DELETE_ONE_SEC_USAGER,
                    method: 'DELETE',
                    data: secUsager 
                });
            },
            invalidatesTags: (result, error, secUsager) => [{ type: 'SecUsager', id: secUsager.id }],
        }),        
        getSecGroupesDispByEmploye: build.query({
            query: (secUsagerId) => {
                return ({
                    url: GET_SEC_GROUPES_DISP_BY_USAGER,
                    method: 'GET',
                    params: { secUsagerId}
                });
            },
            providesTags: (result) => 
                result
                    ? [...result.map(g => ({ type: 'Usager.groupes', id: g.id })), { type: 'Usager.groupes', id: 'LIST_1' }]
                    : [{ type: 'Usager.groupes', id: 'LIST_1' }]        
        }),
        getSecGroupesAssocByEmploye: build.query({
            query: (secUsagerId) => {
                return ({
                    url: GET_SEC_GROUPES_ASSOCIE_USAGER,
                    method: 'GET',
                    params: { secUsagerId}
                });
            },
            providesTags: (result) => 
                result
                    ? [...result.map(g => ({ type: 'Usager.groupes', id: g.id })), { type: 'Usager.groupes', id: 'LIST_2' }]
                    : [{ type: 'Usager.groupes', id: 'LIST_2' }]        
        }),
        addSecGroupesUsager: build.mutation({
            query: (secGroupesUsager) => {
                return ({
                    url: ADD_SEC_GROUPES_USAGER,
                    method: 'POST',
                    data: secGroupesUsager
                });
            },
            invalidatesTags: (result, error, secGroupesUsager) =>
                secGroupesUsager
                  ? [
                      ...secGroupesUsager.map((g) => ({
                        type: 'Usager.groupes',
                        id: g.idSecGroupe,
                      })),
                      { type: 'Usager.groupes', id: 'LIST_2' },
                    ]
                  : [{ type: 'Usager.groupes', id: 'LIST_1' }, { type: 'Usager.groupes', id: 'LIST_2'}],
        }),
        deleteSecGroupesUsager: build.mutation({
            query: (secGroupesUsager) => {
                return ({
                    url: DELETE_SEC_GROUPES_USAGER,
                    method: 'DELETE',
                    data: secGroupesUsager
                });
            },
            invalidatesTags: (result, error, secGroupesUsager) =>
                secGroupesUsager
                  ? [
                      ...secGroupesUsager.map((g) => ({
                        type: 'Usager.groupes',
                        id: g.idSecGroupe,
                      })),
                        { type: 'Usager.groupes', id: 'LIST_1' },
                    ]
                  : [{ type: 'Usager.groupes', id: 'LIST_1' }, { type: 'Usager.groupes', id: 'LIST_2'}],
        }),
        

        loadPolPwPol: build.query({
            query: () => {
                return ({
                    url: LOAD_POLPWPOL,
                    method: 'GET'
                });
            },
            providesTags: (result) => 
                result
                    ? [...result.map(p => ({ type: 'PolPwPol', id: p.polId })), { type: 'PolPwPol', id: 'LIST' }]
                    : [{ type: 'PolPwPol', id: 'LIST' }]
        }),
        newPolPwPol: build.query({
            query: () => {
                return ({
                    url: NEW_POLPWPOL,
                    method: 'GET'
                });
            },
        }),
        addUpdatePolPwPol: build.mutation({
            query: (polPwPol) => {
                return ({
                    url: ADD_UPDATE_POLPWPOL,
                    method: 'PUT',
                    data: polPwPol
                });
            },
            invalidatesTags: (result, error, polPwPol) => [
                { type: 'PolPwPol', id: polPwPol.polId },
                { type: 'PolPwPol', id: 'LIST' }
            ],
        }),
        deletePolPwPol: build.mutation({
            query: (polId) => {
                return ({
                    url: DELETE_POLPWPOL,
                    method: 'DELETE',
                    params: { polId }
                });
            },
            invalidatesTags: (result, error, polId) => [
                { type: 'PolPwPol', id: polId },
                { type: 'PolPwPol', id: 'LIST' }
            ],
        }),
        
        loadPolPwPolUsager: build.query({
            query: () => {
                return ({
                    url: LOAD_POLPWPOL_USAGER,
                    method: 'GET'
                });
            },
            providesTags: (result) => 
                result
                    ? [...result.map(u => ({ type: 'PolPwPolUsager', id: u.seqUsager })), { type: 'PolPwPolUsager', id: 'LIST' }]
                    : [{ type: 'PolPwPolUsager', id: 'LIST' }]
        }),
       updatePolPwPolUsager: build.mutation({
    query: ({ polId, secUsagers }) => {

        const userIds = secUsagers.map(user => user.seqUsager);
        
        return ({
            url: UPDATE_POLPWPOL_USAGER,
            method: 'PUT',
            params: { polId }, 
            data: userIds     
        });
    },
    invalidatesTags: (result, error, { polId, secUsagers }) =>
        secUsagers
          ? [
              ...secUsagers.map((u) => ({
                type: 'PolPwPolUsager',
                id: u.seqUsager,
              })),
              { type: 'PolPwPolUsager', id: 'LIST' },
              { type: 'PolPwPol', id: polId },
            ]
          : [{ type: 'PolPwPolUsager', id: 'LIST' }],
}),
    })
})

export const {
    useFetchMenuDataQuery,
    useLazyFetchMenuDataQuery,
    useChangeSecUsagerPasswordLoggedInMutation,
    useChangeSecUsagerPasswordMutation,
    useLoadPolPwPolByUsernameQuery,
    useGetAllCartesAccessByUsagerIdQuery,
    useGetOneCarteAccessByUsagerIdQuery,
    useGetSecUsagerVmFcQuery,
    useAddOneSecUsagerMutation,
    useUpdateOneSecUsagerMutation,
    useResetSecUsagerPasswordMutation,
    useDeleteOneSecUsagerMutation,
    useGetSecGroupesDispByEmployeQuery,
    useGetSecGroupesAssocByEmployeQuery,
    useAddSecGroupesUsagerMutation,
    useDeleteSecGroupesUsagerMutation,

    useLoadPolPwPolQuery,
    useLazyLoadPolPwPolQuery,
    useNewPolPwPolQuery,
    useLazyNewPolPwPolQuery,
    useAddUpdatePolPwPolMutation,
    useDeletePolPwPolMutation,

    useLoadPolPwPolUsagerQuery,
    useLazyLoadPolPwPolUsagerQuery,
    useUpdatePolPwPolUsagerMutation
} = extendedApi